import React, { createContext, useContext, useState, useCallback } from "react";

interface QuoteModalContextValue {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
}

const QuoteModalContext = createContext<QuoteModalContextValue | undefined>(undefined);

export const QuoteModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return (
    <QuoteModalContext.Provider value={{ openModal, closeModal, isOpen }}>
      {children}
    </QuoteModalContext.Provider>
  );
};

export const useQuoteModal = () => {
  const ctx = useContext(QuoteModalContext);
  if (!ctx) throw new Error("useQuoteModal must be used within QuoteModalProvider");
  return ctx;
};
